import {Tabs} from 'antd';
import React, {FC} from 'react';

import {IDirectoryEntityMeta} from 'entities/metadata';
import {IDirectoryEntityData} from 'modules/data';

import {DirectoryItem} from './directory-item';

import './directory.less';

interface IDirectoryProps {
    url: string;
    metadata: IDirectoryEntityMeta;
    data: IDirectoryEntityData;
    currentTab: string | undefined;
    setCurrentTab: (tab: string) => void;
}

export const Directory: FC<IDirectoryProps> = ({
    url,
    metadata,
    data,
    currentTab,
    setCurrentTab,
}: IDirectoryProps) => (
    <div className="directory-tabs">
        <Tabs
            tabPosition="left"
            onChange={tab => {
                setCurrentTab(tab);
            }}
            destroyInactiveTabPane
            defaultActiveKey={currentTab}
        >
            {data.rows?.map(entry => (
                <Tabs.TabPane
                    tab={entry[metadata.titleField]}
                    key={entry[metadata.linkField || 'id'] as string}
                >
                    <DirectoryItem
                        url={url}
                        data={entry}
                        metadata={metadata}
                        referenceUrl={`${metadata.name}/${currentTab}`}
                    />
                </Tabs.TabPane>
            ))}
        </Tabs>
    </div>
);
